import css from "standard/css";

const style = css`
  .form {
    align-items: end;
    display: flex;
    flex-direction: column;
    gap: var(--spacing_inset-sm);
    width: 100%;
  }

  .form__input {
    width: 100%;
  }

  .form__a {
    color: #3481B2;
    font-family: var(--font-family-base);
    font-size: var(--font-size-xs);
    font-weight: var(--font-weight-medium);
    line-height: var(--line-height-lg);
    text-align: inherit;
    text-decoration: none;
    text-transform: inherit;
  }

  .form__button {
    align-items: center;
    background-color: #3481b2;
    border: none;
    border-bottom: 2px solid #5c9ac1;
    border-radius: var(--border-radius-sm);
    box-shadow: 0 10px 0 #2a668c;
    text-shadow: 0 2px 0 rgba(0, 0, 0, 0.2);
    color: var(--color-pure-white);
    cursor: pointer;
    display: flex;
    font-family: var(--font-family-highlight);
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-bold);
    gap: var(--spacing-nano);
    padding: var(--spacing_inset-nano);
    justify-content: center;
    width: 100%;
  }

  .form__button:active {
    box-shadow: none;
    transform: translateY(5px);
  }
`;

export default style;
